import React from 'react';

const Feature = () => {
  return (
    <div className="features clearfix">
      <div className="container">
        <ul>
          <li>
            <i className="pe-7s-study" />
            <h4>+200 courses</h4>
            <span>Explore a variety of fresh topics</span>
          </li>
          <li>
            <i className="pe-7s-cup" />
            <h4>Expert teachers</h4>
            <span>Find the right instructor for you</span>
          </li>
          <li>
            <i className="pe-7s-target" />
            <h4>Focus on target</h4>
            <span>Increase your personal expertise</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Feature;
